import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, concat, debounceTime, distinctUntilChanged, filter, map, Observable, of, Subject, switchMap, tap, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BaseService } from '../_services/base.service';
import { environment } from '../../environments/environment';
import { ViewportScroller } from '@angular/common';
import { AuthService } from '../_services/auth.service';
declare var window: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
	environment = environment;
	isLoggedIn$: boolean = false;
	loggedInUser: any = null;
	selectedTab: string = 'satchel';
	searchAddressBookModal: any = null;
	searchAddressBookType: string = '';
	searchAddressBookParcelType: string = '';

	step1SatchelForm: FormGroup = this.fb.group({
		packageType: ['satchel', [Validators.required]],
		fromCountry: ['AU', [Validators.required]],
		from: [null, [Validators.required]],
		toCountry: ['AU', [Validators.required]],
		to: [null, [Validators.required]],
		sendToPOBox: ['false', [Validators.required]],
		// packageName: [null, [Validators.required]],
		package: this.fb.group({
			quantity: [1, [Validators.required]],
			weight: [null, [Validators.required]],
			// content: [''],
			// description: ['', [Validators.required]],

			length: [null, [Validators.required]],
			height: [null, [Validators.required]],
			width: [null, [Validators.required]],
			// name: [null, [Validators.required]],
		}),
	});
	step1ParcelForm: FormGroup = this.fb.group({
		packageType: ['parcel', [Validators.required]],
		fromCountry: ['AU', [Validators.required]],
		from: [null, [Validators.required]],
		toCountry: ['AU', [Validators.required]],
		to: [null, [Validators.required]],
		sendToPOBox: ['false', [Validators.required]],
		packages: this.fb.array([this.newParcelPackage()]),
	});
	step2Form: FormGroup = this.fb.group({ });;
	// step3Form: FormGroup;


	regForm: FormGroup = this.fb.group({
		company_name: ['', Validators.required],
		firstname: ['', Validators.required],
		lastname: ['', Validators.required],
		email: ['', Validators.required],
		contact_no: ['', Validators.required],
		address_1: ['', Validators.required],
		address_2: [''],
		// suburb: [this.preQuoteData.Pickup.suburb, Validators.required],
		// postcode: [this.preQuoteData.Pickup.postcode, Validators.required]
		suburb: ['', Validators.required],
		state: ['', Validators.required],
		postcode: ['', Validators.required],

		username: ['', Validators.required],
		pass: ['', Validators.required],
		confirm_pass: ['', Validators.required],
	});

	// satchelSize$: any = [];
	// parcelSizes$: any = [];
	countries$: any = [];

	selectedParcelSize: any = {};
	
	postalCodeMinLengthTerm = 1;
	fromPostalCodes$: Observable<any> = new Observable<any>();
	fromPostalCodeLoading = false;
	fromPostalCodeInput$ = new Subject<any>();

	toPostalCodes$: Observable<any> = new Observable<any>();
	toPostalCodeLoading = false;
	toPostalCodeInput$ = new Subject<any>();
	
	quotesLoading = false;
	trackingFlag = false;

	trackingNo = 0;
	preQuoteData: any = {};
	offeredQuotes = {};
	trackingData = [];

	showEnquiry = false;
	enquiryType = '';
	
	constructor(private viewportScroller: ViewportScroller,
		private cdref: ChangeDetectorRef,
		private router: Router,
		private fb: FormBuilder,
		private toastr: ToastrService,
		private baseService: BaseService,
		private authService: AuthService) { }

	public scrollUpDown(elementId: string): void { 
		console.log(elementId)
		this.viewportScroller.scrollToAnchor(elementId);
	}

	ngOnInit(): void {
		this.authService.userData$.subscribe(res=>{
			this.loggedInUser = res;
			if(res?.authdata) {
				this.isLoggedIn$ = true;
			} else {
				this.isLoggedIn$ = false;
				this.step1SatchelForm.get('from')?.setValue(null);
				this.step1ParcelForm.get('from')?.setValue(null);
			}
		});

		this.searchAddressBookModal = new window.bootstrap.Modal(
			document.getElementById('searchAddressBookModal')
		);
		
		this.initializeForm();
		this.fetchEssentialData();
		this.setSelectedTab(this.selectedTab);
	}

	ngAfterViewInit() {
		setTimeout(() => {
			if(this.isLoggedIn$) {
				const userAddress = {
					firstname: this.loggedInUser.firstname,
					lastname: this.loggedInUser.lastname,
					company_name: this.loggedInUser.company_name,
					contact_no: this.loggedInUser.contact_no,
					email: this.loggedInUser.email,
					address1: this.loggedInUser.address1,
					address2: this.loggedInUser.address2,
					suburb: this.loggedInUser.suburb,
					postcode: this.loggedInUser.postcode,
					state: this.loggedInUser.state,
					label: this.loggedInUser.company_name + ' ' + this.loggedInUser.suburb + ', ' + this.loggedInUser.state + ', ' + this.loggedInUser.postcode
				}
				this.step1SatchelForm.get('from')?.setValue(userAddress);
				this.step1ParcelForm.get('from')?.setValue(userAddress);
			}

			this.cdref.detectChanges();
		}, 100);
	}

	setSelectedTab(tabType: string) {
		this.selectedTab = tabType;
		this.loadFromPostalCodes();
		this.loadToPostalCodes();
	}

	initializeForm() {
		// this.step1Form = this.fb.group({
		// 	packageType: ['satchel', [Validators.required]],
		// 	from: [null, [Validators.required]],
		// 	to: [null, [Validators.required]],
		// 	sendToPOBox: ['false', [Validators.required]],
		// 	packages: this.fb.array([]),
		// });
		// this.step2Form = this.fb.group({ });
	}

	fetchEssentialData() {
		this.loadFromPostalCodes();
		this.loadToPostalCodes();
		// this.baseService.getPackageType('satchel').subscribe((data: any) => {
		// 	this.satchelSize$ = data;
		// 	this.cdref.detectChanges();
		// });
		// this.baseService.getPackageType('parcel').subscribe((data: any) => {
		// 	this.parcelSizes$ = data;
		// 	this.cdref.detectChanges();
		// });
		this.baseService.getCountries().subscribe((data: any) => {
			this.countries$ = data;
			console.log(this.countries$)
			this.cdref.detectChanges();
		});
	}

	loadFromPostalCodes() {
		this.fromPostalCodes$ = concat(
			of([]), // default items
			this.fromPostalCodeInput$.pipe(
				filter(res => {
					return res !== null && res.length >= this.postalCodeMinLengthTerm
				}),
				distinctUntilChanged(),
				debounceTime(800),
				tap(() => this.fromPostalCodeLoading = true),
				switchMap(term => {
					console.log(term)
					let countryId: any = ''
					if(this.selectedTab == 'satchel') {
						countryId = this.step1SatchelForm.get("fromCountry")?.value;
					} else if(this.selectedTab == 'parcel') {
						countryId = this.step1ParcelForm.get("fromCountry")?.value;
					}
					return this.getPostCodes(term, countryId).pipe(
						catchError(() => of([])), // empty list on error
						tap(() => this.fromPostalCodeLoading = false)
					)
				})
			)
		);
	}

	loadToPostalCodes() {
		this.toPostalCodes$ = concat(
			of([]), // default items
			this.toPostalCodeInput$.pipe(
				filter(res => {
					return res !== null && res.length >= this.postalCodeMinLengthTerm
				}),
				distinctUntilChanged(),
				debounceTime(800),
				tap(() => this.toPostalCodeLoading = true),
				switchMap(term => {
					console.log(term)
					let countryId: any = ''
					if(this.selectedTab == 'satchel') {
						countryId = this.step1SatchelForm.get("toCountry")?.value;
					} else if(this.selectedTab == 'parcel') {
						countryId = this.step1ParcelForm.get("toCountry")?.value;
					}
					return this.getPostCodes(term, countryId).pipe(
						catchError(() => of([])), // empty list on error
						tap(() => this.toPostalCodeLoading = false)
					)
				})
			)
		);
	}

	getPostCodes(term: any, countryId: string) {
		const params = {
			q: term,
			country_id:countryId
		}
		return this.baseService.getPostCodeList(params, false, this.isLoggedIn$).pipe(map(resp => {
			if (resp.Error) {
				throwError(resp.Error);
			} else {
				return resp;
			}
		}));
	}

	searchAddressBook(type: string, parcelType: string) {
		console.log("searchAddressBook: ", type)
		this.searchAddressBookParcelType = parcelType;
		this.searchAddressBookType = type;
		this.searchAddressBookModal.show();
	}

	selectRecordOfAddressBook(record: any) {
		if(this.searchAddressBookParcelType == 'satchel') {
			if(this.searchAddressBookType=='from') {
				this.step1SatchelForm.get('from')?.setValue(record);
			} else if(this.searchAddressBookType=='to') {
				this.step1SatchelForm.get('to')?.setValue(record);
			}
		} else if(this.searchAddressBookParcelType == 'parcel') {
			if(this.searchAddressBookType=='from') {
				this.step1ParcelForm.get('from')?.setValue(record);
			} else if(this.searchAddressBookType=='to') {
				this.step1ParcelForm.get('to')?.setValue(record);
			}
		}
		this.searchAddressBookModal.hide();
	}

	// ============================== Parcel Type ===============================
	newParcelPackage(): FormGroup {
		let packageForm: FormGroup =  this.fb.group({
			parcelType: [null],
			quantity: [1, [Validators.required]],
			weight: [null, [Validators.required]],
			content: ['', [Validators.required]],

			length: [null, [Validators.required]],
			height: [null, [Validators.required]],
			width: [null, [Validators.required]],
			name: [''],

			is_dg: [false, [Validators.required]],
		});

		return packageForm;
	}

	parcelPackages(): FormArray {
		return this.step1ParcelForm.get("packages") as FormArray
	}

	addParcelPackage() {
		console.log("Adding a parcel package");
		this.parcelPackages().push(this.newParcelPackage());
		this.cdref.detectChanges();
	}

	removeParcelPackage(packageIndex:number) {
		this.parcelPackages().removeAt(packageIndex);
		this.cdref.detectChanges();
	}

	removeAllParcelPackages() {
		while(this.parcelPackages().length > 0) {
			this.parcelPackages().removeAt(0);
		}
		this.cdref.detectChanges();
	}

	setFromCountry(value: any, type: string) {
		console.log(value);
		if(type=='satchel') {
			this.step1SatchelForm.get('from')?.setValue(null);
			this.loadToPostalCodes();
		} else if(type=='parcel') {
			this.step1ParcelForm.get('from')?.setValue(null);
			this.loadToPostalCodes();
		}
	}

	setToCountry(value: any, type: string) {
		console.log(value);
		if(type=='satchel') {
			this.step1SatchelForm.get('to')?.setValue(null);
			this.loadToPostalCodes();
		} else if(type=='parcel') {
			this.step1ParcelForm.get('to')?.setValue(null);
			this.loadToPostalCodes();
		}
	}

	setParcelSize(packageIndex:number, value: any) {
		console.log(value);
		// const selectedParcelSize = this.parcelSizes$.find((obj: any) => {
		// 	return obj.name == value;
		// });
		
		const selectedParcel = this.parcelPackages().at(packageIndex) as FormGroup;
		// selectedParcel.get('name')?.setValue(selectedParcelSize.name);
		// selectedParcel.get('height')?.setValue(selectedParcelSize.height);
		// selectedParcel.get('length')?.setValue(selectedParcelSize.length);
		// selectedParcel.get('width')?.setValue(selectedParcelSize.width);
		// selectedParcel.get('is_dg')?.setValue(selectedParcelSize.is_dg);
	}

	setSatchelSize(value: any) {
		console.log(value);
		// const selectedSatchelSize = this.satchelSize$.find((obj: any) => {
		// 	return obj.name == value;
		// });
		
		const selectedSatchel = this.step1SatchelForm.get("package") as FormGroup;
		// selectedSatchel.get('name')?.setValue(selectedSatchelSize.name);
		// selectedSatchel.get('height')?.setValue(selectedSatchelSize.height);
		// selectedSatchel.get('length')?.setValue(selectedSatchelSize.length);
		// selectedSatchel.get('weight')?.setValue(selectedSatchelSize.weight);
		// selectedSatchel.get('width')?.setValue(selectedSatchelSize.width);
		// selectedSatchel.get('description')?.setValue(selectedSatchelSize.name);
	}

	getFormValidationErrors(form: any) {
		Object.keys(form.controls).forEach(key => {
			const controlErrors: ValidationErrors = form.get(key).errors;
			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				});
			}
		});
	}

	findInvalidControls(form: any) {
		const invalid = [];
		const controls = form.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		console.log(invalid);
		return invalid;
	}

	getQuote(type: string) {
		console.log("getQuote clicked")
		if(type == 'satchel') {
			console.log(this.step1SatchelForm.value)
			if (this.step1SatchelForm.invalid) {
				this.getFormValidationErrors(this.step1SatchelForm)
				this.findInvalidControls(this.step1SatchelForm)
				const msg = 'Invalid Form';
				const header = 'Please fill the required fields...';
				this.toastr.error(header, msg, {
					positionClass: 'toast-top-right',
				});
				
				document.getElementById('step1SatchelForm')?.classList.add('input-error');
			} else {
				console.log("get quote is called ");
				const pickupLocation = this.step1SatchelForm.get("from")?.value;
				const deliveryLocation = this.step1SatchelForm.get("to")?.value;
				const packageType = this.step1SatchelForm.get("packageType")?.value;

				const satchelPackage = this.step1SatchelForm.get("package") as FormGroup;

				const toCountry = this.step1SatchelForm.get("toCountry")?.value;
				const selectedCountry = this.countries$.find((obj: any) => {
					return obj.id == toCountry;
				})

				const preQuoteData = {
					"Pickup":{
						"firstname": pickupLocation.firstname,
						"lastname": pickupLocation.lastname,
						"company_name": pickupLocation.company_name,
						"contact_no": pickupLocation.contact_no,
						"email": pickupLocation.email,
						"address1": pickupLocation.address1,
						"address2": pickupLocation.address2,
						"suburb": pickupLocation.suburb,
						"postcode": pickupLocation.postcode,
						"state": pickupLocation.state,
					},
					"Delivery":{
						"firstname": deliveryLocation.firstname,
						"lastname": deliveryLocation.lastname,
						"company_name": deliveryLocation.company_name,
						"contact_no": deliveryLocation.contact_no,
						"email": deliveryLocation.email,
						"address1": deliveryLocation.address1,
						"address2": deliveryLocation.address2,
						"suburb": deliveryLocation.suburb,
						"postcode": deliveryLocation.postcode,
						"state": deliveryLocation.state,
						"isMailbox": (this.step1SatchelForm.get("sendToPOBox")?.value == true? true: false),
						"country": selectedCountry
					},
					"Package_type": packageType,
					"Packages":[{
						name: satchelPackage.get('name')?.value,
						weight: satchelPackage.get('weight')?.value,
						length: satchelPackage.get('length')?.value,
						width: satchelPackage.get('width')?.value,
						height: satchelPackage.get('height')?.value,
						quantity: 1,
						description: satchelPackage.get('label')?.value,
					}]
				}

				console.log("preQuoteData", preQuoteData);
				this.sendQuotationRequest(preQuoteData)
			}
		} else if(type == 'parcel') {
			if (this.step1ParcelForm.invalid) {
				this.getFormValidationErrors(this.step1ParcelForm)
				this.findInvalidControls(this.step1ParcelForm)
				const msg = 'Invalid Form';
				const header = 'Please fill the required fields...';
				this.toastr.error(header, msg, {
					positionClass: 'toast-top-right',
				});
				
				document.getElementById('step1ParcelForm')?.classList.add('input-error');
			} else {
				console.log("get quote is called ");
				const pickupLocation = this.step1ParcelForm.get("from")?.value;
				const deliveryLocation = this.step1ParcelForm.get("to")?.value;
				const packageType = this.step1ParcelForm.get("packageType")?.value;

				const toCountry = this.step1ParcelForm.get("toCountry")?.value;
				const selectedCountry = this.countries$.find((obj: any) => {
					return obj.id == toCountry;
				})

				const preQuoteData = {
					"Pickup":{
						"firstname": pickupLocation.firstname,
						"lastname": pickupLocation.lastname,
						"company_name":pickupLocation.company_name,
						"contact_no": pickupLocation.contact_no,
						"email": pickupLocation.email,
						"address1": pickupLocation.address1,
						"address2": pickupLocation.address2,
						"suburb": pickupLocation.suburb,
						"postcode": pickupLocation.postcode,
						"state": pickupLocation.state,
					},
					"Delivery":{
						"firstname": deliveryLocation.firstname,
						"lastname": deliveryLocation.lastname,
						"company_name": deliveryLocation.company_name,
						"contact_no": deliveryLocation.contact_no,
						"email": deliveryLocation.email,
						"address1": deliveryLocation.address1,
						"address2": deliveryLocation.address2,
						"suburb": deliveryLocation.suburb,
						"postcode": deliveryLocation.postcode,
						"state": deliveryLocation.state,
						"isMailbox": (this.step1ParcelForm.get("sendToPOBox")?.value == true? true: false),
						"country": selectedCountry
					},
					"Package_type": packageType,
					"Packages":[]
				}

				const evalPackages: any = [];
				const paks = this.step1ParcelForm.get('packages')?.value;
				for (const pak of paks) {
					// const selectedPak = this.parcelSizes$.find((obj: any) => {
					// 	return obj.name == pak.parcelType;
					// })

					evalPackages.push({
						parcelType: pak.parcelType,
						quantity: pak.quantity,
						weight: pak.weight,
						length: pak.length,
						width: pak.width,
						height: pak.height,
						description: pak.content,
						name: '',

						is_dg: pak.is_dg
					})
				}
				preQuoteData.Packages = evalPackages;

				console.log("preQuoteData", preQuoteData);
				this.sendQuotationRequest(preQuoteData)
			}
		}

	}

	sendQuotationRequest(preQuoteData: any) {
		this.closeEnquiry()
		this.enquiryType = 'package';
		this.preQuoteData =  preQuoteData;
		this.quotesLoading = true;
		// this.spinner.show();
		this.baseService.getQuote(preQuoteData,this.isLoggedIn$).subscribe((res:any) => {
			console.log(res);
			// this.spinner.hide();
			this.offeredQuotes = res;
			// I add this flag becoz the programmatic moving next step is not happening.
			// it requires a click on screen so better disable the button on receivning offer.
			// if a user reclick, it wont resend request of quote
			// this.offeredQouteLoaded = true;
			// this.wizard.goToNextStep();
			
			// this.step1WizardRow.nativeElement.click()

			// setTimeout(() => {
			// 	this.wizard.goToNextStep();
			// },0);
			// this.wizard.goToStep(1);
			this.quotesLoading = false;
			this.showEnquiry = true;
			this.scrollUpDown("enquiry-result");
			this.cdref.detectChanges();
		}, err => {
			// this.spinner.hide();
			this.quotesLoading = false;
			const msg = 'Failed';
			const header = 'Please try again...';
			this.toastr.error(header, msg, {
				positionClass: 'toast-top-right',
			});
			this.cdref.detectChanges();
		});
	}

	searchByTrackNo(trackingNo: any) {
		this.getTrackingDetails(trackingNo)
	}

	getTrackingDetails(trackingNo: any) {
		this.closeEnquiry()
		this.enquiryType = 'tracking';
		this.trackingFlag = true;
		this.trackingNo = trackingNo;
		// this.spinner.show();
        this.baseService.getTrackingDetails(trackingNo).subscribe((res: any) => {
            // this.spinner.hide();
			this.trackingData = res;
			console.log(res);
			this.trackingFlag = false;
			this.showEnquiry = true;
			this.scrollUpDown("enquiry-result");
			this.cdref.detectChanges();
        }, err => {
            // this.spinner.hide();
			this.trackingFlag = false;
			const msg = 'Failed';
			const header = 'Please try again...';
			// this.toastr.error(header, msg, {
			// 	positionClass: 'toast-top-right',
			// });
			this.cdref.detectChanges();
        });
	}

	closeEnquiry() {
		this.showEnquiry = false;
		this.preQuoteData =  {};
		this.offeredQuotes = {};
		this.trackingData = [];
		this.trackingNo = 0;
		this.enquiryType = '';
		this.scrollUpDown("home");
	}

	registerCustomer() {
		console.log("registerCustomer clicked")
		console.log(this.regForm.value)
		if (this.regForm.invalid) {
			const msg = 'Invalid Form';
			const header = 'Please fill the required fields...';
			this.toastr.error(header, msg, {
				positionClass: 'toast-top-right',
			});
			
			document.getElementById('regForm')?.classList.add('input-error');
		} else {

		}
	}
}
